import { Component, AfterViewInit, Renderer2, OnDestroy } from '@angular/core';
import { MenuService } from '../../service/app.menu.service';
import { PrimeNGConfig } from 'primeng/api';
import { AppComponent } from '../../../../app.component';
import { StorageService } from 'src/app/modules/common/service/storage/storage.service';
import { FilterService } from 'src/app/modules/common/service/filter/filter.service';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { loadList } from '../../lib/action';
import { AdministrationService } from '../../service';
import { distinctUntilChanged, filter, map, Observable } from 'rxjs';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss']
})
export class AppMainComponent implements AfterViewInit, OnDestroy {

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean=true;

    staticMenuMobileActive: boolean=true;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: () => void;

    configActive: boolean;

    configClick: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    menuHoverActive = false;

    searchClick = false;
    userDetails$ : Observable<any>;
    privilegeList$:Observable<any>;
    search = false;
    isSuperuser: boolean=false;
    selectedApplicationId: any;

    constructor(
        public renderer: Renderer2,
        private adminService:AdministrationService,
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        public storageService: StorageService,
        public filterService: FilterService,
        public router:Router,
        private store: Store<any>) {
        this.menuClick = true;
        this.userDetails$ = this.store.pipe(select(state => state?.list?.data?.profile));
    }

    ngOnInit(){
        this.store.dispatch(loadList({ listType: 'profile' }));
        this.store.dispatch(loadList({ listType: 'country' }));
        this.store.dispatch(loadList({ listType: 'currency' }));
        this.store.dispatch(loadList({ listType: 'legal_entity' }));
        this.store.dispatch(loadList({ listType: 'organisation' }));
        this.store.dispatch(loadList({ listType: 'sertica-le' }));
        this.userDetails$.subscribe(data => {
            this.adminService.setPrivilegeList(data?.privileges);
        });
        this.onMenuButtonClick(null);
    }

    ngAfterViewInit() {
        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.menuClick && this.isHorizontal()) {
                this.menuService.reset();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            if (!this.rightPanelClick) {
                this.rightPanelActive = false;
            }

            if (!this.menuClick) {
                if (this.overlayMenuActive) {
                    this.overlayMenuActive = false;
                }
                if (this.staticMenuMobileActive) {
                    this.staticMenuMobileActive = false;
                }

                this.menuHoverActive = false;
                this.unblockBodyScroll();
            }
            if (!this.searchClick) {
                this.search = false;
            }
            this.searchClick = false;
            this.configClick = false;
            this.topbarItemClick = false;
            this.menuClick = false;
            this.rightPanelClick = false;
        });
    }

    onMenuButtonClick(event: Event | null): void {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        this.menuClick = true;

        if (this.app.menuMode === 'overlay' && !this.isMobile()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        if (event) {
            event.preventDefault();
        }
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        if (item.className === 'search-item topbar-item') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event, ope: string = '') {
        event.preventDefault();
    }

    onRTLChange(event) {
        this.app.isRTL = event.checked;
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;
        event.preventDefault();
    }

    onRightPanelClick() {
        this.rightPanelClick = true;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.app.menuMode === 'overlay';
    }

    isStatic() {
        return this.app.menuMode === 'static';
    }

    isHorizontal() {
        return this.app.menuMode === 'horizontal';
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }

}
